<template>
  <div class="detalle-borrador-panel">
    <DxTabPanel height="95%" tabs-position="top" icon-position="left">
      <DxItem :key="1" :title="tituloTab1" class="tab-item" :disabled="false" icon="fa-regular fa-file-lines">
        <component :is="datosComponent" :model="model" />
      </DxItem>
      <DxItem :key="2" :title="tituloTab2" class="tab-item" :disabled="false" icon="fa-regular fa-folder-open">
      <borrador-operacion-documentos :documentos="documentos"></borrador-operacion-documentos>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import { useModalBuilder, type ToolbarReference } from "@/.shared/helpers/modal-building-helper";
import { useIntl } from "@/.shared/services/i18n/i18nservice";
import { computed, getCurrentInstance, onMounted } from "vue";
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import { type DetailBorradorOperacionModel } from "@/.shared/.api";
import { getBorradorOperacionDatosComponent } from "@/components/borradores-operacion/ComponentFactory";
import BorradorOperacionDocumentos from "@/components/borradores-operacion/BorradorOperacionDocumentos.vue";
import type { IDocumentInitialState } from "@/.shared/components/document-card/models/IDocumentCardProps";
import { useRouter } from "@/.shared/services/routing-services";
import type { DxButton } from "devextreme-vue";
import { primaryButtonProps } from "@/.shared/helpers/button-helper";
import { useModalService } from "@/.shared/services/modal-service";
import { CreateTicket } from "@/.shared/components/soporte/models/CreateTicket";
import TicketForm from "@/.shared/components/soporte/TicketForm.vue";

const props = defineProps({
  model: Object as () => DetailBorradorOperacionModel,
});
const intl = useIntl();
const router = useRouter();
const modal = useModalService();

const documentos = computed<IDocumentInitialState[]>(() => props.model?.ArchivosAdjuntos.map
  (archivo => ({ id: archivo.Id, uri: archivo.Ruta, fileName: archivo.Nombre, description: archivo.Descripcion })) ?? [] as IDocumentInitialState[]);

onMounted(async () => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!);
  const closeButton = modal.standardButtons.addClose();
  closeButton.update(w => w.onClick = () => modal.close());
  
  let soporteButton: ToolbarReference<DxButton>;
  soporteButton = modal.addButton("soporte", { ...primaryButtonProps(intl.i18n.t('operaciones.detalle.contactar_soporte')), 
      type: 'success', icon: "fa-thin fa-headset"}, { toolbar: "bottom", location: "before" });
  soporteButton.update(w => w.onClick = () => crearTicket());
});

const tituloTab1 = computed(() => `${intl.i18n.t("borradores-operacion.form.datos")}`);
const tituloTab2 = computed(() => `${intl.i18n.t("borradores-operacion.form.documentos")}`);

const datosComponent = computed(() => getBorradorOperacionDatosComponent(props.model?.Tipo));

const crearTicket = async () => {
  let title = `${intl.i18n.t("ticket.creacion.titulo")}`;
  const ticket = CreateTicket.CreateOperacionTicket(props.model?.Id!, '', props.model?.Tipo ?? '');
  await modal.showModal(
    TicketForm,
    { model: ticket },
    { title: title, width: 800, height: 700 }
  );
}
</script>

<style lang="scss" scoped></style>